export class NewPlanDataValues {

    isFillForecasts: boolean = true;

    salesValue: number = 0;
    costsValue: number = 0;
    salariesValue: number = 0;
    expensesValue: number = 0;

    salesAdjust: number = 0;
    costsAdjust: number = 0;
    salariesAdjust: number = 0;
    expensesAdjust: number = 0;

    constructor() {}
    
}